import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InvoiceService } from '../services/invoice.service';

@Component({
  selector: 'app-generate-invoice',
  templateUrl: './generate-invoice.component.html',
  styleUrls: ['./generate-invoice.component.scss']
})
export class GenerateInvoiceComponent implements OnInit {

  reportForm: FormGroup;

  currentMonth: number;

  invoice: any;

  loading: boolean = false;

  monthList: any[] = [
    {month: 1, title: 'January'},
    {month: 2, title: 'Febuary'},
    {month: 3, title: 'March'},
    {month: 4, title: 'April'},
    {month: 5, title: 'May'},
    {month: 6, title: 'June'},
    {month: 7, title: 'July'},
    {month: 8, title: 'August'},
    {month: 9, title: 'September'},
    {month: 10, title: 'October'},
    {month: 11, title: 'November'},
    {month: 12, title: 'December'},
  ];

  constructor(private formBuilder: FormBuilder, private invoiceService: InvoiceService) { }


  ngOnInit(): void {

    const d = new Date();
    let month = d.getMonth() + 1;
    this.currentMonth = month;

    this.loading = true;

    this.invoiceService.generateInvoice(month).subscribe(x => {
      this.invoice = x;
      if (!!this.invoice && !!this.invoice.invoiceLines)
      {
        this.invoice.invoiceLines.forEach(x => x.orderAmount = x.orderAmount/100);
        this.invoice.invoiceLines.forEach(x => x.deliveryFee = x.deliveryFee/100);
        this.invoice.invoiceLines.forEach(x => x.processingFee = x.processingFee/100);
        this.invoice.invoiceLines.forEach(x => x.internalFee = x.internalFee/100);
        this.invoice.invoiceLines.forEach(x => x.stripeFee = x.stripeFee/100);

        var temp = this.invoice.invoiceLines.reduce((sum, invoiceLine) => sum + invoiceLine.internalFee, 0);
        console.log(temp);
      }
      if (!!this.invoice && !!this.invoice.invoiceAmount)
      {
        this.invoice.invoiceAmount = this.invoice.invoiceAmount/100
      }
      this.loading = false;
    }, (error) => {
      this.loading = false;
    })

  }

  
  changeMonth(event: any)
  {
    this.invoiceService.generateInvoice(event.value).subscribe(x => {
      this.invoice = x;
      this.loading = false;
    }, (error) => {
      this.loading = false;
    })
  }

}
